import { POST } from "../../APiHelper/API";

export const undoTransferPlayerAPI = (id, onSuccess, onError) => {
    const data = {
        id: id,
    };
    POST(`/api/v1/leagues/player/undo_transfer`, data, onSuccess, onError);
};
